import { render } from "./account-security.vue?vue&type=template&id=79a18581&scoped=true"
import script from "./account-security.vue?vue&type=script&lang=js"
export * from "./account-security.vue?vue&type=script&lang=js"

import "./account-security.vue?vue&type=style&index=0&id=79a18581&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a18581"]])

export default __exports__